/* eslint-disable */

export const protobufPackage = "Reality.Reality.Api";

export enum WebUserFeedbackSubmitType {
  WEB_USER_FEEDBACK_SUBMIT_TYPE_UNKNOWN = 0,
  WEB_USER_FEEDBACK_SUBMIT_TYPE_RESIGNED = 1,
  WEB_USER_FEEDBACK_SUBMIT_TYPE_VIEWED = 2,
  WEB_USER_FEEDBACK_SUBMIT_TYPE_SUBMITTED = 3,
  UNRECOGNIZED = -1,
}

export function webUserFeedbackSubmitTypeFromJSON(object: any): WebUserFeedbackSubmitType {
  switch (object) {
    case 0:
    case "WEB_USER_FEEDBACK_SUBMIT_TYPE_UNKNOWN":
      return WebUserFeedbackSubmitType.WEB_USER_FEEDBACK_SUBMIT_TYPE_UNKNOWN;
    case 1:
    case "WEB_USER_FEEDBACK_SUBMIT_TYPE_RESIGNED":
      return WebUserFeedbackSubmitType.WEB_USER_FEEDBACK_SUBMIT_TYPE_RESIGNED;
    case 2:
    case "WEB_USER_FEEDBACK_SUBMIT_TYPE_VIEWED":
      return WebUserFeedbackSubmitType.WEB_USER_FEEDBACK_SUBMIT_TYPE_VIEWED;
    case 3:
    case "WEB_USER_FEEDBACK_SUBMIT_TYPE_SUBMITTED":
      return WebUserFeedbackSubmitType.WEB_USER_FEEDBACK_SUBMIT_TYPE_SUBMITTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WebUserFeedbackSubmitType.UNRECOGNIZED;
  }
}

export function webUserFeedbackSubmitTypeToJSON(object: WebUserFeedbackSubmitType): string {
  switch (object) {
    case WebUserFeedbackSubmitType.WEB_USER_FEEDBACK_SUBMIT_TYPE_UNKNOWN:
      return "WEB_USER_FEEDBACK_SUBMIT_TYPE_UNKNOWN";
    case WebUserFeedbackSubmitType.WEB_USER_FEEDBACK_SUBMIT_TYPE_RESIGNED:
      return "WEB_USER_FEEDBACK_SUBMIT_TYPE_RESIGNED";
    case WebUserFeedbackSubmitType.WEB_USER_FEEDBACK_SUBMIT_TYPE_VIEWED:
      return "WEB_USER_FEEDBACK_SUBMIT_TYPE_VIEWED";
    case WebUserFeedbackSubmitType.WEB_USER_FEEDBACK_SUBMIT_TYPE_SUBMITTED:
      return "WEB_USER_FEEDBACK_SUBMIT_TYPE_SUBMITTED";
    case WebUserFeedbackSubmitType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
